import { createAsyncThunk } from '@reduxjs/toolkit';
import WebcontactService from '@/services/WebcontactService';
import CompanyService from '@/services/CompanyService';
import DashboardService from '@/services/DashboardService';
import BranchesAndTeamsService from '@/services/BranchesAndTeamsService';

const handler = (name, asyncFunction) =>
  createAsyncThunk(`Webcontact/${name}`, async (arg) => {
    const data = await asyncFunction(arg);
    return data;
  });

export const getAssignmentRules = handler('getAssignmentRules', async () => {
  const data = await WebcontactService.getAssignmentRules();
  return data;
});

export const getAssignmentRule = handler(
  'getAssignmentRule',
  async (ruleId) => {
    const data = await WebcontactService.getAssignmentRule(ruleId);
    return data;
  }
);

export const getAssignmentRulesSummary = handler(
  'getAssignmentRulesSummary',
  async () => {
    const data = await WebcontactService.getAssignmentRulesSummary();
    return data;
  }
);

export const getAssignmentRulesOptionsService = handler(
  'getAssignmentRulesOptions',
  async () => {
    const data = await WebcontactService.getAssignmentRulesOptions();
    return data;
  }
);

export const getAssignmentLimits = handler('getAssignmentLimits', async () => {
  const data = await WebcontactService.getAssignmentLimits();
  return data;
});

export const updateAssignmentLimits = handler(
  'updateAssignmentLimits',
  async (partial) => {
    const data = await WebcontactService.updateAssignmentLimits(partial);
    return data;
  }
);

export const createAssignmentRuleService = createAsyncThunk(
  'Webcontact/createAssignmentRule',
  async (ruleData, thunkAPI) => {
    const data = await WebcontactService.createAssignmentRule(ruleData);
    try {
      await thunkAPI.dispatch(getAssignmentRulesSummary()).unwrap();
    } catch (e) {
      console.error('Error refreshing assignment rules summary:', e);
    }
    return data;
  }
);

export const updateAssignmentRuleService = createAsyncThunk(
  'Webcontact/updateAssignmentRule',
  async ({ ruleId, ruleData }, thunkAPI) => {
    const data = await WebcontactService.updateAssignmentRule(ruleId, ruleData);
    try {
      await thunkAPI.dispatch(getAssignmentRulesSummary()).unwrap();
    } catch (e) {
      console.error('Error refreshing assignment rules summary:', e);
    }
    return data;
  }
);

export const deleteAssingmentRuleService = createAsyncThunk(
  'Webcontact/deleteAssingmentRule',
  async (ruleId, thunkAPI) => {
    const data = await WebcontactService.deletAssignmenteRule(ruleId);
    try {
      await thunkAPI.dispatch(getAssignmentRulesSummary()).unwrap();
    } catch (e) {
      console.error('Error refreshing assignment rules summary:', e);
    }
    return data;
  }
);

export const getDevelopmentRulesService = handler(
  'getDevelopmentRules',
  async () => {
    const data = await WebcontactService.getDevelopmentRules();
    return data;
  }
);

export const updateAssigmentRulesOrder = handler(
  'updateAssigmentRulesOrder',
  async (idsArray) => {
    const data = await WebcontactService.updateOrder(idsArray);
    return data;
  }
);

export const requestWebcontactRulesUpgrade = handler(
  'requestWebcontactRulesUpgrade',
  async () => {
    const data = await WebcontactService.requestWebcontactRulesUpgrade();
    return data;
  }
);

export const getWebcontactUpgradePending = handler(
  'getWebcontactUpgradePending',
  async () => {
    const data = await CompanyService.getUpgradePending();
    return data;
  }
);

export const getWebcontactOrigins = handler(
  'getWebcontactOrigins',
  async () => {
    const data = await WebcontactService.getOrigins();
    return data;
  }
);

export const getAgentsForWebcontact = handler(
  'getAgentsForWebcontact',
  async () => {
    const data = await WebcontactService.getAgentsForWebcontact();
    return data;
  }
);

export const getLeadStatuses = handler('getLeadStatuses', async () => {
  const data = await WebcontactService.getLeadStatuses();
  return data;
});

export const getCompanyBranches = handler('getCompanyBranches', async () => {
  const data = await DashboardService.getCompanyBranches();
  return data;
});

// `GET /api3/company/teams/` is open to any authenticated company user
// (`TeamListView.get_permissions`); only POST/PATCH/DELETE stay admin-only.
// That matches branch catalog reads and lets non-admin monitors fill the Team
// filter — assignment-rule editors (admin-gated) can reuse the same list.
export const getCompanyTeams = handler('getCompanyTeams', async () => {
  const data = await BranchesAndTeamsService.listTeams();
  return data;
});

export const getCustomTags = handler('getCustomTags', async () => {
  const data = await WebcontactService.getCustomTags();
  return data;
});
